import {createEntitySlice} from 'utils/createEntitySlice';
import {Company} from 'types/company';
import {CompanyThunks} from 'features/company/companyThunks';

export interface CompanyState {
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
  companies?: any;
  pagy?: any;
  company?: any;
  isEditing?: boolean;
  activeTab?: string;
}

const initialState: CompanyState = {
  status: 'idle',
  error: null,
  companies: [],
  company: null,
  pagy: {},
  isEditing: false,
  activeTab: 'All',
};

const companySlice = createEntitySlice<Company>({
  name: 'company',
  initialState,
  thunks: CompanyThunks,
  entityKey: 'company',
  entitiesKey: 'companies',
  reducers: {},
  extraReducers: {
    [CompanyThunks.getCurrent.pending.toString()]: state => {
      state.status = 'loading';
    },
    [CompanyThunks.getCurrent.fulfilled.toString()]: (state, action) => {
      state.company = action.payload;
      state.status = 'succeeded';
    },
    [CompanyThunks.getCurrent.rejected.toString()]: (state, action) => {
      state.status = 'failed';
      state.error = action.error.message;
    },
  },
});

export const {
  setEntity: setCompany,
  setIsEditing,
  setActiveTab,
} = companySlice.actions;
export {initialState as companyInitialState};
export default companySlice.reducer;
